<template>
  <a-space direction="vertical" :style="{ width: '100%' }" :size="[0, 48]">
    <a-layout style="min-height: 100vh; display: flex; flex-direction: column">
      <a-layout-header :style="headerStyle">
        <div class="header-container">
          <!-- 左侧Logo/标题 -->
          <div class="header-left">
            <div class="logo" @click="$router.push('/')">
              <img src="https://daosen-crm.oss-accelerate.aliyuncs.com/prod/qrkj/uploads/ueditor/image/20250522/1747918256369089.png" alt="Logo" style="height: 50px" />
            </div>

            <!-- 主导航菜单 -->
            <a-menu
                v-model:selectedKeys="currentMenu"
                mode="horizontal"
                :style="{ lineHeight: '64px', borderBottom: 'none' }"
            >
              <a-menu-item key="home" @click="$router.push('/')">
                Home
              </a-menu-item>
              <a-menu-item key="claim-history" @click="$router.push('/claim-history')">
                Claim History
              </a-menu-item>
            </a-menu>
          </div>
        </div>

        <a-dropdown>
          <a-space>
            <a style="color: #141414; display: inline-block;">{{ userEmail }}</a>
            <a-avatar>
              <template #icon>
                <UserOutlined />
              </template>
            </a-avatar>
          </a-space>

          <a class="ant-dropdown-link" @click.prevent>
            <DownOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item v-if="userEmail !== ''">
                <LogoutOutlined />
                <a-button style="color: #141414" type="link" @click="logout"> Switch Email</a-button>
              </a-menu-item>
              <a-menu-item v-if="userEmail === ''">
                <LoginOutlined />
                <a-button style="color: #141414" type="link" @click="goLogin"> Login</a-button>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>

      </a-layout-header>

      <a-layout-content :style="contentStyle">
        <router-view/>
      </a-layout-content>

      <div id="components-back-top-demo-custom">
        <a-back-top>
          <div class="ant-back-top-inner">UP</div>
        </a-back-top>
      </div>

      <a-layout-footer class="enhanced-footer">
        <a-row :gutter="[24, 24]">
          <a-col :xs="24" :sm="12" :md="6">
            <div class="logo" @click="$router.push('/')">
              <img src="https://daosen-crm.oss-accelerate.aliyuncs.com/prod/qrkj/uploads/ueditor/image/20250522/1747918256369089.png" alt="Logo" style="height: 50px" />
            </div>
          </a-col>

          <!-- 公司信息 -->
          <a-col :xs="24" :sm="12" :md="6">
            <h3>Dealnewspaper</h3>
            <p>More perks coming soon</p>
          </a-col>

          <!-- 快速链接（修改此处：菜单靠左） -->
          <a-col :xs="24" :sm="12" :md="6">
            <h3>Quick Links</h3>
            <a-menu class="footer-vertical-menu left-align-menu">
              <a-menu-item key="home" @click="$router.push('/')" class="no-focus-style">Home</a-menu-item>
              <a-menu-item key="claim-history" @click="$router.push('/claim-history')">Claim History</a-menu-item>
            </a-menu>
          </a-col>

          <!-- 联系方式 -->
          <a-col :xs="24" :sm="12" :md="6">
            <h3>Contact Us</h3>
            <p><phone-outlined /> +1-866-228-4920</p>
            <p><phone-outlined /> +1-888-994-4669</p>
            <p><mail-outlined /> support@dealnewspaper.com</p>
          </a-col>
        </a-row>
      </a-layout-footer>

      <a-layout-footer style="text-align: center; background-color: #1c2228; color: white; border-top: 1px solid rgba(255, 255, 255, 0.1);">
        ©{{new Date().getFullYear()}} Dealnewspaper
      </a-layout-footer>
    </a-layout>
  </a-space>
</template>
<script setup>
import {UserOutlined, LoginOutlined, LogoutOutlined, DownOutlined} from "@ant-design/icons-vue";
import {inject, ref} from "vue";
import {useAuth} from "@/services/userAuth";
import { eventBus } from "@/services/event-bus";

import {
  PhoneOutlined,
  MailOutlined
} from '@ant-design/icons-vue';

const userEmail = ref('');
const authState = inject('authState');
const showLogin = inject('showLogin');
const currentMenu = ref(['/']);

if (authState != null && typeof authState.email !== 'undefined') {
  userEmail.value = authState.email;
}
console.log('==userEmail', userEmail.value);

const goLogin = () => {
  console.log('====go login');
  showLogin.value = true;
  eventBus.$emit('show-login-close-event');
}
const logout = async () => {
  console.log('====logout');
  const res = await useAuth().logout();

  if (res.code === 200) {
    showLogin.value = true;
  }
  console.log('Header page=====', res)
}

const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 60,
  paddingInline: 50,
  lineHeight: '60px',
  backgroundColor: 'rgb(255 255 255)',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10,
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
};
const contentStyle = {
  textAlign: 'center',
  minHeight: 120,
  lineHeight: '120px',
  color: '#fff',
  backgroundColor: '#f5f5f5',
  paddingTop: '80px',
};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  margin-right: 24px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}


@media (max-width: 768px) {
  .header-container {
    padding-inline: 20px;
  }

  .ant-layout-header {
    padding-inline: 0px 20px !important;
  }

  .header-left {
    gap: 10px;
  }

  .logo img {
    height: 40px !important;
  }

  .ant-menu-horizontal {
    display: none;
  }
}

@media (min-width: 769px) {
  .mobile-menu-btn {
    display: none;
  }
}


/** 页脚菜单样式 **/
.enhanced-footer {
  background-color: #1c2228;
  color: white;
  padding: 48px 50px 24px;
}
.enhanced-footer h3 {
  color: #fff;
  margin-bottom: 16px;
  font-size: 16px;
  text-align: left; /* 标题靠左 */
}
.enhanced-footer p {
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 8px;
  text-align: left; /* 段落靠左 */
  height: 32px;
  line-height: 32px;
}
/* 修改菜单项靠左 */
.footer-vertical-menu.left-align-menu {
  text-align: left;
}
.footer-vertical-menu.left-align-menu :deep(.ant-menu-item) {
  padding-left: 0 !important;
  margin-left: 0;
  justify-content: flex-start; /* 强制靠左 */
}
/* 其他原有样式保持不变 */
.footer-vertical-menu {
  background: transparent;
  border-right: none;
}
.footer-vertical-menu :deep(.ant-menu-item) {
  color: rgba(255, 255, 255, 0.65);
  height: 32px;
  line-height: 32px;
}
.footer-vertical-menu :deep(.ant-menu-item:hover) {
  color: #1890ff;
}

.copyright-section {
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center; /* 关键：确保此属性存在 */
  color: rgba(255, 255, 255, 0.45);
}

.ant-input, .ant-btn {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
}


/* 穿透 Ant Design 的样式隔离，底部菜单超链接点击去除边框高亮 */
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item),
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:active),
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:hover) {
  background: transparent !important;
}
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:active),
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:focus),
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:hover) {
  text-decoration: underline;
  color: white;
}
.footer-vertical-menu.left-align-menu:deep(.ant-menu-item:after) {
  border-right: none !important; /* 去除选中时的右侧边框 */
}
</style>
